import AppButton from '@/components/AppButton.vue';
import TheWrapperPublic from '@/components/TheWrapperPublic.vue';
export default {
  name: 'NotFoundPage',
  components: {
    AppButton,
    TheWrapperPublic
  }
};